import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight, CloseIcon, PlayIcon, PauseIcon } from './ImageViewerIcons';

const GLYPHS = {
    close: CloseIcon,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    play: PlayIcon,
    pause: PauseIcon,
};

export default function ViewerIcon({ name }) {
    const Icon = GLYPHS[name] || CloseIcon;
    return <Icon />;
}

ViewerIcon.propTypes = {
    name: PropTypes.string,
};
